import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/explode`;

export interface ExplodeFileCommandPayload {
  fileId: string;
}

export const explodeFileRequest = ({
  fileId,
}: ExplodeFileCommandPayload): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.PUT, json: {} },
});

async function explodeFileCommand(
  payload: ExplodeFileCommandPayload,
): Promise<BackResponse<string[]> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<string[]>>(
      explodeFileRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default explodeFileCommand;
